/**
 * format — lokale Zahlformat-Helfer der UI-Komponentenbibliothek (Story 0.3)
 *
 * Bewusst duenn und lokal: lib/fmt.ts formatiert hart auf 'en-US' (bestehende
 * Screens verlassen sich darauf), die neuen Relaunch-Komponenten sollen aber
 * der aktiven i18n-Sprache folgen (DE: 0,108 · EN: 0.108). Deshalb hier eigene
 * Helfer auf Basis von lib/locale.activeBcp47().
 */
import { activeBcp47 } from '../../lib/locale'

/** Zahl mit fester Nachkommastellenzahl in der aktiven Sprache. */
export function formatNumber(value: number, decimals = 3): string {
  const safe = Object.is(value, -0) ? 0 : value
  return new Intl.NumberFormat(activeBcp47(), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(safe)
}

/** Rate inklusive Einheit, z. B. „0,108 $/GB“. */
export function formatRate(value: number, unit: string, decimals = 3): string {
  const num = formatNumber(value, decimals)
  return unit ? `${num} ${unit}` : num
}

/**
 * Multiplikator-Label, z. B. „0,5×“ / „3,0×“.
 * Immer eine Nachkommastelle — 0,5×/1,0×/3,0× lesen sich als Reihe konsistenter.
 */
export function formatMultiplier(value: number): string {
  return `${formatNumber(value, 1)}×`
}

/** Prozentwert, z. B. „52,0 %“ (DE) bzw. „52.0%“ (EN). */
export function formatPercent(fraction: number, decimals = 1): string {
  return new Intl.NumberFormat(activeBcp47(), {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(fraction)
}

/** Begrenzt einen Wert auf [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  if (Number.isNaN(value)) return min
  return Math.min(Math.max(value, min), max)
}
